class Type {
	public static CARD = new Type("card", "Card");
	public static PAYPAL = new Type("paypal", "PayPal");
	public static BANK = new Type("bank", "Bank account");

	private constructor(
		public readonly value: string,
		public readonly label: string,
	) {}

	public static values(): Type[] {
		return [Type.CARD, Type.PAYPAL, Type.BANK];
	}

	public static getByValue(value?: string) {
		return this.values().find((type) => type.value === value);
	}
}

export { Type as BillingPaymentType };
